import { AxiosStatic } from "axios";
import { AxiosInterceptedResult } from "../interceptors";

export type AutoCompleteLimit = "unlimited" | number;

export interface IAutocompleteApiDependencies {
  axios: AxiosStatic;
  saltcomplianceApiRoot: string;
}

export interface IAutocompleteApi {
  getEligibleEditors: (
    accountId: string,
    organizationId: string
  ) => (searchValue?: string) => Promise<AxiosInterceptedResult<string[]>>;
  getEligibleCourses: (
    accountId: string,
    organizationId: string,
    searchValue?: string,
    limit?: AutoCompleteLimit
  ) => Promise<AxiosInterceptedResult<string[]>>;
  getDashboardEligibleCourses: (
    accountId: string,
    organizationId: string,
    searchValue?: string,
    limit?: AutoCompleteLimit
  ) => Promise<AxiosInterceptedResult<string[]>>;
}

export default class AutocompleteApi implements IAutocompleteApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IAutocompleteApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public getEligibleEditors = (activeUser: string, organizationId: string) => (q?: string) => {
    return (this.axios.get(
      `${this.apiRoot}/autocomplete/entities/visibleBy/${activeUser}/relativeToOrg/${organizationId}`,
      {
        params: {
          activeUser,
          q,
        },
      }
    ) as any) as Promise<AxiosInterceptedResult<string[]>>;
  };

  public getEligibleCourses = (activeUser: string, organizationId: string, q?: string, limit?: AutoCompleteLimit) => {
    return this.axios.get(
      `${this.apiRoot}/autocomplete/courses/visibleBy/${activeUser}/relativeToOrg/${organizationId}`,
      {
        params: {
          activeUser,
          limit,
          q,
        },
      }
    ) as Promise<AxiosInterceptedResult<string[]>>;
  };

  public getDashboardEligibleCourses = (
    activeUser: string,
    organizationId: string,
    q?: string,
    limit?: AutoCompleteLimit
  ) => {
    return this.axios.get(
      `${this.apiRoot}/autocomplete/dashboard/courses/visibleBy/${activeUser}/relativeToOrg/${organizationId}`,
      {
        params: {
          activeUser,
          limit,
          q,
        },
      }
    ) as Promise<AxiosInterceptedResult<string[]>>;
  };
}
